import React from 'react';

import { useConfiguration } from '../../../hooks/Configuration';
import { ConfigurationFeaturesOnChatLinkClickActionEnum } from '../../../api/models';
import { FORCE_EXPANDED_STORAGE_KEY } from '../../../constants/global';

interface ILinkProps {
    url: string
    children: any
}

const targets: any = {
    'self': '_self',
    'new': '_blank'
};

function Link({ url, children }: ILinkProps) {
    const configuration = useConfiguration();

    const targetDest = configuration?.features[window.location.origin === new URL(url).origin ? 'internalLinksTarget' : 'externalLinksTarget']
    const target = targetDest ? targets[targetDest] : '_blank';

    return (
        <a
            href={url}
            target={target}
            onClick={(e) => {
                if (target === '_blank') return;

                switch (configuration?.features.onChatLinkClickAction) {
                    case ConfigurationFeaturesOnChatLinkClickActionEnum.AutoOpen:
                        sessionStorage.setItem(FORCE_EXPANDED_STORAGE_KEY, 'true');
                        break;
                    case ConfigurationFeaturesOnChatLinkClickActionEnum.AutoClose:
                        document.getElementById('stx-chat-expander')?.click();
                        break;
                }

                // setTimeout(() => window.location.reload(), 2000);//jen pro testování
            }}>
            {children}
        </a>
    );
}

export default Link;
